
import React, { Component } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "../pages/home/HomeComponent";

import About from "../pages/about/About.js";
import Services from "../pages/services/Services.js";

import Contact from "../pages/contact/ContactComponent";

import { settings } from "../portfolio.js";
import BROKING from "../pages/services/Broking/Broking.jsx";
import DISTRIBUTION from "../pages/services/Distribution/Distribution.jsx";
import ADVISORY from "../pages/services/Advistory/Advistory.jsx";
import Insurance from "../pages/services/Insurance/Insurance.jsx";
import FINANCING from "../pages/services/Financing/Financing.jsx";
import Disclaimer from "../components/Disclaimer/Disclaimer.js";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy.js";

export default class Main extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div>
        <BrowserRouter>
          <Routes>

            <Route path="/" element={<Home theme={theme} />} />

            <Route path="/home" element={<Home theme={theme} />} />
            <Route
              path="/services"
              element={<Services theme={theme} />}
            />
            {/* Use a relative path for the child route */}
            <Route
              path="/services/broking"
              element={<BROKING theme={theme} />}
            />
            <Route
              path="/services/distribution"
              element={<DISTRIBUTION theme={theme} />}
            />
            <Route
              path="/services/insurance"
              element={<Insurance theme={theme} />}
            />
            <Route
              path="/services/advistory"
              element={<ADVISORY theme={theme} />}
            />
            <Route
              path="/services/financing"
              element={<FINANCING theme={theme} />}
            />
            <Route
              path="/about"
              element={<About theme={theme} />}
            />

            <Route
              path="/contact"
              element={<Contact theme={theme} />}
            />

            <Route
              path="/disclaimer"
              element={<Disclaimer theme={theme} />}
            />

            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy theme={theme} />}
            />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}
